import { useState, useEffect } from 'react';

interface BilheteInputProps {
  onBilheteChange: (bilhete: string) => void;
  bilhete?: string;
}

export default function BilheteInput({ onBilheteChange, bilhete = '' }: BilheteInputProps) {
  const [value, setValue] = useState(bilhete);
  const [error, setError] = useState('');

  useEffect(() => {
    setValue(bilhete);
  }, [bilhete]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let input = e.target.value.replace(/\D/g, ''); // Remove tudo que não é dígito
    
    if (input.length > 5) {
      input = input.slice(0, 5); // Limita a 5 dígitos
    }
    
    setValue(input);
    onBilheteChange(input);
    
    // Validação
    if (input.length > 0 && input.length < 5) {
      setError('O bilhete deve ter exatamente 5 dígitos');
    } else {
      setError('');
    }
  };

  const formatDisplayValue = (val: string) => {
    if (val.length === 0) return '';
    return val.padStart(5, '0'); // Preenche com zeros à esquerda se necessário
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-bold">
        Número do Bilhete
      </label>
      <div className="relative">
        <input
          type="text"
          value={formatDisplayValue(value)}
          onChange={handleChange}
          placeholder="00000"
          className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 transition-all ${
            error 
              ? 'border-red-500 focus:ring-red-500' 
              : 'border-white/10 focus:ring-cyan-500'
          }`}
          maxLength={5}
        />
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
          <i className="ri-ticket-line text-white/40"></i>
        </div>
      </div>
      
      {error && (
        <p className="text-sm text-red-400 flex items-center gap-1">
          <i className="ri-error-warning-line"></i>
          {error}
        </p>
      )}
      
      <div className="text-xs text-white/60">
        Digite exatamente 5 dígitos numéricos do seu bilhete
      </div>
    </div>
  );
}